import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const DOCUMENT_NUMBER_SCHEMA = Object.freeze({
    PREFIX: '',
  }),
  RECORD = generateSchema(DOCUMENT_NUMBER_SCHEMA),
  KEYS: any = generateKeys(DOCUMENT_NUMBER_SCHEMA);

export class DocumentNumber extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get prefix(): string {
    return this.get(KEYS.PREFIX);
  }
}
